var $ = require('./../sw-jquery');


$(function() {
    $('body').on('change', '[data-sw-update-shipping-options]', function() {

        var $el = $(this);
        var ids = $.parseJSON($el.attr('data-sw-update-shipping-options'));
        var shippingAddressSelector = ids.shippingAddressSelector;
        var shippingRadioButtonsSelector = ids.shippingRadioButtonsSelector;
        var shippingOptionId = $el.attr('id');
        var selectedShippingAddress = $( "#"+shippingOptionId+" option:selected");
        var shippingInfo = selectedShippingAddress.attr("id");
        shippingInfo = shippingInfo.split("-");
        var shippingAddressId = shippingInfo[0] === 'new' ? null : shippingInfo[0];
        var countryId = shippingInfo[1];
        var addressLine = ids.addressLine;
        var combineShipmentLabel = ids.combineShipmentLabelSelector;
        var inputShippingOption = ids.inputShippingOptionSelector;
        var combinedShipment = ids.combinedShipmentSelector;

        var params = {
            'addressId': shippingAddressId,
            'addressType': 1,
            'countryId': countryId
        };

        $.get("/user/address", params, function(response) {
            $(shippingAddressSelector).html(response);
        });

        var param = {
            'addressId': shippingAddressId
        };

        // Hakcy fix to make linting happy 
        var updateRadioButtons,
            updateRadioButtonsDisplay;

        updateRadioButtonsDisplay = function updateRadioButtonsDisplay(requestData){
            $.post('/cart/updateShippingCountry', requestData, function (response) {
                var data = $.parseJSON(response);
                if (data.htmlData.shippingRadioButtons) {
                    $(shippingRadioButtonsSelector).replaceWith(data.htmlData.shippingRadioButtons);
                    $(inputShippingOption).change(updateRadioButtons);
                }
                else{
                    $(shippingRadioButtonsSelector).html('');
                }
            });
        };

        updateRadioButtons = function updateRadioButtons(){
            var requestData = {
                'shippingOptionId': $(inputShippingOption + ':checked').val()
            };
            updateRadioButtonsDisplay(requestData);
        };

        $.post('/cart/updateShippingAddress', param, function (response) {
            var data = $.parseJSON(response);
            var $combinedShipmentLabel;

            if (data.htmlData.shippingRadioButtons) {
               $combinedShipmentLabel = $(combineShipmentLabel);
               $(shippingRadioButtonsSelector).replaceWith(data.htmlData.shippingRadioButtons);
               $(inputShippingOption).change(updateRadioButtons);

               if($(shippingRadioButtonsSelector).find(combinedShipment).hasClass('sw-disabled')){
                  $combinedShipmentLabel.addClass('has-tip');
                  $combinedShipmentLabel.attr('title', 'Change your address to ' + addressLine + ' to use this option');
               }
               else{
                  $combinedShipmentLabel.removeClass('has-tip');
                  $combinedShipmentLabel.attr('title', '');
               }

               if($(shippingRadioButtonsSelector).find(combinedShipment).hasClass('sw-disabled') && $(shippingRadioButtonsSelector).find(combinedShipment).is(':checked')){
                  var reqData = {
                     'shippingOptionId': 'id'
                  };
                  updateRadioButtonsDisplay(reqData);
               }
            }
        });
    });
});
